import * as Mod1 from "./discourse/initializers/discourse-chat-channel-categories";
import * as Mod2 from "./discourse/services/dcc-chat-channel-categories";
const compatModules = {
  "discourse/initializers/discourse-chat-channel-categories": Mod1,
  "discourse/services/dcc-chat-channel-categories": Mod2,
};
export { compatModules };
export default compatModules;
